<template>
    <div class="container">
        <div class="typeChoose" v-if="step == 1">
            <div class="breadcrumb">
                <a @click="$router.go(-1)">推送管理</a>
                <i>/</i>
                <span>创建推送</span>
            </div>
            <div class="typeSelect">
                <div class="typeSelect_title">类型</div>
                <comSelect class="comSelect" :options="options" @clickOption="clickOptionItem" :choosed="articleType"></comSelect>
            </div>
            <div class="btn_primary" @click="nextStep()">下一步</div>
        </div>
        <div class="content" v-else>
            <div class="breadcrumb">
                <a @click="$router.go(-1)">推送管理</a>
                <i>/</i>
                <template v-if="editType == '添加'">
                    <a @click="step = 1">创建推送</a>
                </template>
                <template v-else>
                    <a>修改推送</a>
                </template>
                <i>/</i>
                <span>{{ articleTypeName }}</span>
            </div>
            <div class="form">
                <div class="formItem">
                    <div>
                        标题
                    </div>
                    <div class="inputBox">
                        <input type="text" v-model="title" />
                    </div>
                </div>
                <div class="formItem">
                    <div>
                        主图
                    </div>
                    <div class="upImg " v-if="articleType == '新品'">
                        <input type="file" @change="upImg($event, 1)" />
                        <div class="previewImage">
                            <img :src="previewMainImg" />
                        </div>
                        <div class="upfile-hint">
                            <div>尺寸：300*300，JPG、PNG，不超过1M</div>
                        </div>
                    </div>
                    <div class="upImg upImg_1" v-if="articleType == '优惠'">
                        <input type="file" @change="upImg($event, 2)" />
                        <div class="previewImage">
                            <img :src="previewMainImg" />
                        </div>
                        <div class="upfile-hint">
                            <div>尺寸：630*310，JPG、PNG，不超过1M</div>
                        </div>
                    </div>
                    <div class="upImg upImg_2" v-if="articleType == '知识'">
                        <input type="file" @change="upImg($event, 3)" />
                        <div class="previewImage">
                            <img :src="previewMainImg" />
                        </div>
                        <div class="upfile-hint">
                            <div>尺寸：240*160，JPG、PNG，不超过1M</div>
                        </div>
                    </div>
                </div>
                <div class="formItem">
                    <div>
                        推送至服务栏
                    </div>
                    <div class="push2home">
                        <div>
                            <input type="radio" v-model="push2home" :value="true" id="push2home_yes" />
                            <label for="push2home_yes">是</label>
                        </div>
                        <div>
                            <input type="radio" v-model="push2home" :value="false" id="push2home_no" />
                            <label for="push2home_no">否</label>
                        </div>
                    </div>
                    <div class="push_hint">注：最多推送{{ articleType == "知识" ? 4 : 2 }}条内容至服务栏</div>
                </div>
                <div class="formItem">
                    <div>
                        推送至轮播
                    </div>
                    <div class="push2lunbo">
                        <div>
                            <input type="radio" v-model="push2lunbo" :value="true" id="push2lunbo_yes" />
                            <label for="push2lunbo_yes">是</label>
                        </div>
                        <div>
                            <input type="radio" v-model="push2lunbo" :value="false" id="push2lunbo_no" />
                            <label for="push2lunbo_no">否</label>
                        </div>
                    </div>
                </div>
                <div class="lunboImg upImg" v-if="push2lunbo">
                    <input type="file" @change="upImg($event, 4)" />
                    <div class="previewImage">
                        <img :src="previewLunbo" />
                    </div>
                    <div class="upfile-hint">
                        <div>尺寸：690*380，JPG、PNG，不超过1M</div>
                    </div>
                </div>
                <div class="formItem editorBox">
                    <div>
                        正文
                    </div>
                    <div class="editor">
                        <!-- <editor :init="init" v-model="editorContent"></editor> -->
                        <tinymceEditor v-model="editorContent"></tinymceEditor>
                    </div>
                </div>
                <div class="formBtns">
                    <button class="btn_primary" @click="submit">确认{{ editType }}</button>
                    <button class="btn_primary" @click="cancel">取消</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { uploadFile } from "../../http/api";
import { getPushDetail, updatePush } from "../../http/pushPage";
import add_square from "../../assets/icon/add_square.png";
import add_wide from "../../assets/icon/add_wide.png";
import comSelect from "../../components/comSelect";
import comMsg from "../../components/comMsg";
import tinymceEditor from "../../components/tinymceEditor";

export default {
    components: {
        comSelect,
        comMsg,
        tinymceEditor,
    },
    data() {
        return {
            step: 1,
            editType: "添加",
            push2home: false,
            push2lunbo: false,
            articleType: "",
            articleTypeName: "",
            title: "",
            editorContent: "",
            articleContent: "",
            previewMainImg: add_square, //主图预览
            unloadMainImg: "", //主图上传路径
            previewLunbo: add_square, //轮播图预览
            uploadLunbo: "", //轮播图路径
            options: [
                { name: "请选择", value: "", disabled: true },
                { name: "新品推荐", value: "新品" },
                { name: "优惠活动", value: "优惠" },
                { name: "保健按摩知识", value: "知识" },
            ],
        };
    },
    methods: {
        upImg(ev, val) {
            let file = ev.target.files[0];
            if (!file) {
                return;
            }
            let reader = new FileReader();
            //转base64
            reader.onload = (e) => {
                if (file.size > 1024000) {
                    layer.msg("上传图片请不要大于1M");
                    return;
                }
                let data = e.target.result;
                let image = new Image();
                //判断图片尺寸
                image.onload = () => {
                    let width = image.width;
                    let height = image.height;
                    // console.log(width, height);
                    // console.log(val);
                    if (val == 1) {
                        if (width !== height) {
                            //300*300
                            layer.msg("图片尺寸不合格，请重新选择图片上传");
                            return false;
                        }
                    } else if (val == 2) {
                        if (parseInt((width / height) * 100) != parseInt((630 / 310) * 100)) {
                            //630*310
                            layer.msg("图片尺寸不合格，请重新选择图片上传");
                            return false;
                        }
                    } else if (val == 3) {
                        if (parseInt((width / height) * 100) != parseInt((240 / 160) * 100)) {
                            // 240*160
                            layer.msg("图片尺寸不合格，请重新选择图片上传");
                            return false;
                        }
                    } else if (val == 4) {
                        if (parseInt((width / height) * 100) != parseInt((690 / 380) * 100)) {
                            // 690*380
                            layer.msg("图片尺寸不合格，请重新选择图片上传");
                            return false;
                        }
                    }
                    let formData = new FormData();
                    formData.append("files", file);
                    formData.append("type", "test");
                    uploadFile(formData).then((res) => {
                        if (val == 4) {
                            this.previewLunbo = res.data.result[0].fileUrl;
                            this.uploadLunbo = res.data.result[0].fileUrl;
                        } else {
                            this.previewMainImg = res.data.result[0].fileUrl;
                            this.unloadMainImg = res.data.result[0].fileUrl;
                        }
                    });
                };
                image.src = data;
                return;
            };
            reader.readAsDataURL(file);
        },
        clickOptionItem(item) {
            this.articleType = item.value;
            this.articleTypeName = item.name;
        },
        nextStep() {
            if (!this.articleType) {
                layer.msg("请选择类型");
                return;
            }
            this.step = 2;
        },
        cancel() {
            this.$router.go(-1);
        },
        submit() {
            if (!this.title) {
                layer.msg("请输入主标题");
                return;
            }
            if (!this.unloadMainImg) {
                layer.msg("请上传主图");
                return;
            }
            if (!this.editorContent) {
                layer.msg("请输入正文");
                return;
            }
            // if (this.editorContent.indexOf(`data-custom`) == -1) {
            //     this.editorContent = `<div data-custom="true" style="padding: 0 10px">${this.editorContent}</div>`;
            // }
            this.save();
        },
        save() {
            let obj = {
                type: this.articleType,
                title: this.title,
                bulletinBoard: this.push2home,
                rotationBoard: this.push2lunbo,
                mainPicUrl: this.unloadMainImg,
                rotationPicUrl: this.uploadLunbo,
                content: this.editorContent,
            };
            if (this.id) {
                obj.id = this.id;
            }
            updatePush(obj).then((res) => {
                console.log(res);
                if (res.data.errCode === 0) {
                    layer.msg("成功");
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 100);
                }
            });
        },
    },
    created() {
        console.log(this.$route.query);
        if (this.$route.query.id) {
            this.step = 2;
            this.editType = "修改";
            this.id = this.$route.query.id;
            this.push2home = Boolean(this.$route.query.bulletinBoard);
            this.push2lunbo = Boolean(this.$route.query.rotationBoard);
            this.articleType = this.$route.query.type;
            this.articleTypeName = this.$route.query.typeName;
            this.title = this.$route.query.title;
            this.previewMainImg = this.$route.query.mainPicUrl;
            this.previewLunbo = this.$route.query.rotationPicUrl;
            this.unloadMainImg = this.$route.query.mainPicUrl;
            this.uploadLunbo = this.$route.query.rotationPicUrl;
            if (this.$route.query.content) {
                this.editorContent = this.$route.query.content;
            }
            getPushDetail({
                id: this.$route.query.id,
            }).then((res) => {
                if (res.data.errCode === 0) {
                    console.log(res.data.result);
                    this.editorContent = res.data.result.content;
                    this.push2home = Boolean(res.data.result.bulletinBoard);
                    this.push2lunbo = Boolean(res.data.result.rotationBoard);
                    this.articleType = res.data.result.type;
                    this.title = res.data.result.title;
                    this.previewMainImg = res.data.result.mainPicUrl;
                    this.previewLunbo = res.data.result.rotationPicUrl;
                    this.unloadMainImg = res.data.result.mainPicUrl;
                    this.uploadLunbo = res.data.result.rotationPicUrl;
                }
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    min-height: 800px;
    display: flex;
    justify-content: center;
    position: relative;
    padding-top: 40px;
}
.breadcrumb {
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 20px;
    a {
        font-weight: 550;
        color: #3c3c3c;
    }
}

.push2home,
.push2lunbo {
    display: flex;
    align-items: center;
    user-select: none;
    padding-left: 30px;
    div {
        font-size: 18px;
        padding-right: 50px;
        input[type="radio"] {
            outline: none;
            position: absolute;
            clip: rect(0, 0, 0, 0); //  第一种隐藏方式：剪切为0
            // visibility: hidden;   // 第二种隐藏方式：隐藏
        }
        label {
            display: flex;
            align-items: center;
            cursor: pointer;
        }
        input[type="radio"] + label::before {
            content: "\a0"; /*不换行空格*/
            display: inline-block;
            width: 8px;
            height: 8px;
            margin-right: 5px;
            border-radius: 50%;
            background-color: #fff;
            border: 4px solid #ccc;
        }
        input[type="radio"]:checked + label::before {
            border: 4px solid #ff8914;
        }
    }
}
.inputBox {
    flex: 1;
    input {
        width: 100%;
        height: 30px;
        padding: 0% 10px;
        font-size: 16px;
        &:disabled {
            background: #fff;
            border: 1px solid #ddd;
        }
    }
    textarea {
        width: 500px;
        height: 40px;
        padding: 10px 10px;
        font-size: 16px;
        resize: none;
    }
    span {
        padding-left: 10px;
        color: #808080;
    }
}

.gender,
.range {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
        display: flex;
        align-items: center;
        span {
            padding: 0 10px;
        }
        input {
            width: 92px;
            height: 28px;
            font-size: 18px;
            text-align: center;
            outline-color: #ff8914;
        }
    }
}
.range {
    .rangeInput {
        position: relative;
        &::before {
            content: "%";
            display: block;
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
            color: #888;
        }
        input {
            width: 82px;
            padding-right: 10px;
        }
    }
}
.editor {
    flex: 1;
}
.editorBox {
    align-items: flex-start;
}

.upImg {
    position: relative;
    display: flex;
    align-items: center;
    input[type="file"] {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100px;
        height: 100px;
    }
    .previewImage {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #aaa;
        border-radius: 5px;
        overflow: hidden;
        img {
            height: 100%;
            box-sizing: content-box;
        }
    }
    .upfile-hint {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-left: 20px;
        color: #666;
        div {
            padding: 5px 0;
        }
    }
}
.upImg_1 {
    input[type="file"] {
        width: 150px;
        height: 74px;
    }
    .previewImage {
        width: 152px;
        height: 76px;
    }
}
.upImg_2 {
    input[type="file"] {
        width: 110px;
        height: 74px;
    }
    .previewImage {
        width: 110px;
        height: 74px;
    }
}
.lunboImg {
    margin-left: 120px;
    margin-bottom: 20px;
    input[type="file"] {
        width: 180px;
        height: 100px;
    }
    .previewImage {
        width: 180px;
        height: 100px;
    }
}
.typeChoose {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 12%;
    position: relative;
}
.typeSelect {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 300px;
    .comSelect {
        width: 500px;
        margin-left: 30px;
    }
}
@media only screen and (max-width: 1600px) {
    .editPush {
        width: 90%;
    }
}
</style>
